module.exports = __webpack_public_path__ + "static/media/qr_drive_cont.cedb2348.png";